import { useField } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { MdContentCopy } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { ITranslationOption } from '~/types/option'
import type { IPlaceholderRule } from '~/types/template'

import TranslationInputModal from './Modal'
import WarningTooltip from './WarningTooltip'

import ActionInput from '../ActionInput'
import InputControls from '../Controls'

import { LokaliseProjectBadge } from '~/components/Badges'
import Modal from '~/components/Modal'
import { displayToast } from '~/utils/toast'

import './styles.scss'

interface Props {
  disabled?: boolean
  focus?: boolean
  iapKey?: string
  name: string
  rules?: IPlaceholderRule[]
}

const translationDetails = (value: ITranslationOption) => {
  const handleCopy = () => {
    if (value && value.text) {
      navigator.clipboard.writeText(value.text)
      displayToast('Copied to clipboard', 'success')
    }
  }

  return (
    <table className="translation-details-table">
      <thead>
        <tr>
          <th>Project</th>
          <th>Value (EN)</th>
        </tr>
      </thead>
      <tbody>
        <tr className="translation-details-table__row">
          <td>
            {value?.translation ? (
              <LokaliseProjectBadge size="medium" value={value.translation.lokalise_project_name} />
            ) : null}
          </td>
          <td>
            <div className="translation-details-table__row__lokalise-value" onClick={handleCopy}>
              <span>
                {value.text} <MdContentCopy className="copy-icon" color="#aeaeae" size={14} />
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

const TranslationInput = ({ disabled, focus, name, rules }: Props): ReactElement => {
  const ref = useRef<HTMLInputElement>(null)

  const [, { error, value }, { setValue }] = useField<ITranslationOption | ''>(name)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleModal = (isModalOpen: boolean) => () => setIsModalOpen(isModalOpen)

  const handleDelete = () => setValue('')

  useEffect(() => {
    if (ref.current && focus) {
      ref.current.focus()
    }
  }, [focus])

  return (
    <div className="translation-input">
      <div className="translation-input__row">
        <ActionInput
          disabled={disabled}
          isValid={!!value && !error}
          label="translation"
          onAddClick={toggleModal(true)}
          onInputClick={toggleModal(true)}
        >
          {value ? value.label : undefined}
        </ActionInput>
        {value ? (
          <>
            {value.translation ? <WarningTooltip rules={rules} translation={value.translation} /> : null}
            <InputControls
              copyValue={value.value}
              onDelete={!disabled ? handleDelete : undefined}
              translationKey={value.value}
              translationProject={value.translation?.lokalise_project_id}
            />
          </>
        ) : null}
      </div>
      {value ? <div className="translation-input__row">{translationDetails(value)}</div> : null}
      <Modal className="translation-search-modal" isOpen={isModalOpen} onCloseModal={toggleModal(false)}>
        <TranslationInputModal name={name} onItemClick={toggleModal(false)} rules={rules} />
      </Modal>
    </div>
  )
}

export default TranslationInput
